<div>
  La page "Politique de confidentialité" est disponible dans le menu déroulant en haut à droite,
  afin de consulter le détail des informations collectées ainsi que les traitements effectués.
</div>
<hr/>
<button class="btn btn-light" (click)="readRgpd()">J'ai compris</button>
